// utils/DropdownBus.js
import Vue from 'vue'
export const DropdownBus = new Vue()



// WEBPACK FOOTER //
// ./src/utils/DropdownBus.js